<template>
  <div>
    <div
      v-for="(parseSetting, index) in value"
      :key="index"
    >
      <div
        v-if="index !== 0"
        class="text-center"
      >
        <i class="fa fa-arrow-down" />
      </div>
      <HttpParseSetting
        :value="parseSetting"
        @input="editSetting($event, index)"
        @remove="removeItem(index)"
      />
    </div>

    <button
      v-t="'ADD_PARSE_STEP'"
      class="btn btn-success btn-sm m-t-10"
      type="button"
      @click="addSetting"
    />
  </div>
</template>

<script>
import HttpParseSetting from './HttpParseSetting';
import { cloneDeep } from 'lodash';
export default {
  name: 'HttpParseSettings',
  components: { HttpParseSetting },
  props: {
    value: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      parseSettings: cloneDeep(this.value)
    };
  },
  watch: {
    value(newValue) {
      this.parseSettings = cloneDeep(newValue);
    }
  },
  methods: {
    addSetting() {
      this.$emit('input', [...this.parseSettings, {type: 'jpath', value: ''}]);
    },
    editSetting(newValue, index) {
      this.parseSettings[index] = newValue;
      this.$emit('input', this.parseSettings);
    },
    removeItem(index) {
      this.parseSettings.splice(index, 1);
      this.$emit('input', this.parseSettings);
    }
  }
};
</script>

<style>

</style>